const _showcase = {
	items: [
		{
			id: 1,
			key_parity: 'odd',
			key_number: 'one',
			info: {
				order: '1',
				image: 'cine-documental-y-storytelling_info.jpg',
				title: 'Cine Documental y Storytelling',
				subtitle: '',
				description:
					'Hay historias que merecen ser contadas de una manera diferente… Confía en nosotros para ayudarte a contarla. En los últimos 10 años hemos participado junto a nuestra productora hermana  Docland Films (www.contramediafilms.com) en numerosos documentales premiados internacionalmente.'
			},
			video: {
				order: '2',
				image: 'cine-documental-y-storytelling_poster.jpg',
				type: 'local',
				data: {
					file_mp4: 'cine-documental-y-storytelling_reel.mp4',
					file_webm: 'cine-documental-y-storytelling_reel.webm'
				}
			}
		},
		{
			id: 2,
			key_parity: 'even',
			key_number: 'two',
			info: {
				order: '2',
				image: 'streaming_info.jpg',
				title: 'Streaming',
				subtitle: '',
				description:
					'Ofrecemos un diseño y presupuesto personalizado para cualquier tipo de evento que requiera de una emisión en streaming.'
			},
			video: {
				order: '1',
				image: 'streaming_poster.jpg',
				type: 'local',
				data: {
					file_mp4: 'streaming_reel.mp4',
					file_webm: 'streaming_reel.webm'
				}
			}
		},
		{
			id: 3,
			key_parity: 'odd',
			key_number: 'three',
			info: {
				order: '1',
				image: 'video-corporativo-y-eventos_info.jpg',
				title: 'Vídeo Corporativo y Eventos',
				subtitle: '',
				description:
					'Disponemos de equipos de última generación (grabación 6K) y maquinaria específica para lograr las imágenes más impactantes de tu evento: grúas, steadycams, slider motorizados, cámaras 360, etc...'
			},
			video: {
				order: '2',
				image: 'video-corporativo-y-eventos_poster.jpg',
				type: 'local',
				data: {
					file_mp4: 'video-corporativo-y-eventos_reel.mp4',
					file_webm: 'video-corporativo-y-eventos_reel.webm'
				}
			}
		},
		{
			id: 4,
			key_parity: 'even',
			key_number: 'four',
			info: {
				order: '2',
				image: 'fotografia_info.jpg',
				title: 'Fotografía',
				subtitle: '',
				description:
					'Nuestro compromiso es crear imágenes diferentes y atractivas ofreciendo un servicio integral de fotografía para cualquier tipo de evento o estilo fotográfico que necesites cubrir: moda, producto, arquitectónica, social, etc...'
			},
			video: {
				order: '1',
				image: 'fotografia_poster.jpg',
				type: 'local',
				data: {
					file_mp4: 'fotografia_reel.mp4',
					file_webm: 'fotografia_reel.webm'
				}
			}
		},
		{
			id: 5,
			key_parity: 'odd',
			key_number: 'five',
			info: {
				order: '1',
				image: 'animacion-2d-3d_info.jpg',
				title: 'Animación 2D y 3D',
				subtitle: '',
				description:
					'Te ayudamos a encontrar la mejor solución para tu proyecto utilizando software de última generación para el desarrollo de proyectos que requieran de animación 2D y 3D.'
			},
			video: {
				order: '2',
				image: 'animacion-2d-3d_poster.jpg',
				type: 'local',
				data: {
					file_mp4: 'animacion-2d-3d_reel.mp4',
					file_webm: 'animacion-2d-3d_reel.webm'
				}
			}
		},
		{
			id: 6,
			key_parity: 'even',
			key_number: 'six',
			info: {
				order: '2',
				image: 'video-y-fotografia-subacuatica_info.jpg',
				title: 'Vídeo y Fotografía Subacuática',
				subtitle: '',
				description:
					'Nuestro origen es el agua... Hace más de 20 años empezamos a explorar el mundo subacuático, lo que nos ha llevado a sentir un fuerte compromiso por preservar nuestros mares y océanos. Si a esto le sumas nuestra pasión por la imagen, el resultado de lo que somos capaces de hacer bajo el agua te sorprenderá.'
			},
			video: {
				order: '1',
				image: 'video-y-fotografia-subacuatica_poster.jpg',
				type: 'local',
				data: {
					file_mp4: 'video-y-fotografia-subacuatica_reel.mp4',
					file_webm: 'video-y-fotografia-subacuatica_reel.webm'
				}
			}
		},
		{
			id: 7,
			key_parity: 'odd',
			key_number: 'seven',
			info: {
				order: '1',
				image: 'video-y-fotografia-aerea_info.jpg',
				title: 'Vídeo y Fotografía Aérea',
				subtitle: '',
				description:
					'Si lo que necesitas es un punto de vista diferente, nuestros pilotos certificados pueden ayudarte a encontrar esa impactante imagen que buscas gracias a su amplia experiencia en el pilotaje de diferentes tipos de aeronaves.'
			},
			video: {
				order: '2',
				image: 'video-y-fotografia-aerea_poster.jpg',
				type: 'local',
				data: {
					file_mp4: 'video-y-fotografia-aerea_reel.mp4',
					file_webm: 'video-y-fotografia-aerea_reel.webm'
				}
			}
		}
	]
}

export default {
	getData(callback) {
		callback(_showcase)
	}
}
